import { fixToTwo } from "./NumberFormatter";

export const ratioFormatter = (value?: number | null) => {
  if (value === undefined || value === null) {
    return "N/A";
  }

  const ratio = value * 100;

  if (ratio < 0.01 && ratio > 0) {
    return "< 1%";
  }

  return `${fixToTwo(ratio)}%`;
};

export function RatioFormatter({ value }: { value?: number | null }) {
  return <>{ratioFormatter(value)}</>;
}
